import { BaseLogger } from '@/shared/service/logger/BaseLogger';
import { LogDevMessageKinds } from '@/shared/service/logger/types';

import { type MessageAction, type MessageType } from './types';

export const makeMessage = <T>(type: MessageType, action: MessageAction, payload?: T) => {
  return JSON.stringify({
    type,
    action,
    payload: payload ?? {},
  });
};

export const logMessage = BaseLogger.makeLogDevMessage<
  MessageType | (string & NonNullable<unknown>),
  { action: MessageAction; payload: any }
>(LogDevMessageKinds.ws, (messageType, { action }) => `${action}: ${messageType}`, [
  'PAYLOAD',
  (_, { payload }) => payload,
]);
